import { Component, Input } from '@angular/core';
import { DetailDataOrderModel, orderDetails } from 'src/app/models/detail-data-order.model';

@Component({
  standalone: false,
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.scss'],
})
export class PaymentSummaryComponent {
  @Input() detailOrder!: DetailDataOrderModel;
  @Input() loading: boolean = true;
  @Input() orderDetails: orderDetails[] = [];
  @Input() totalPrice!: number;

  isCollapsed = true;
}
